<template>
    <div v-if="customerId" class="ChatWindowCon" id="ChatWindowCon">
        <h2 class="ChatName">
            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper">
                    <i class="el-icon-caret-bottom" />
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <el-button  @click="Endreception()">移除接待</el-button>
                    </el-dropdown-item>
                        <el-dropdown-item>
                            <el-button  @click="handleAddMenu(customerId,customerName)">修改昵称</el-button>
                        </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <a style="text-overflow: ellipsis;">{{ customerName }}</a>
            <span class="right clearback" @click="ClearCustomer()">返回</span>
        </h2>

        <!--聊天面板-->
        <ul class="ChatWindowDiv" id="ChatWindow">
            <li v-for="item in ContactItem"
                :class="[item.oper_code === 2003 ? 'MeCon' : 'FriendsCon']"
                :ids="item.id">
                <p class="ChatWindowTime">{{ item.create_time.substring(0, 19).replace('T', ' ') }}</p>
                <div class="ChatWindowIn">
                    <img src="../../../assets/images/logo.png" alt="img" class="touxiang"
                         v-if="item.oper_code === 2003">
                    <img v-else src="../../../assets/images/default.png" alt="img"
                         class="touxiang">
                    <el-dropdown class=""  :trigger="item.oper_code === 2003 ? 'click' : ' '" >
                        <div class="ChatWindowText avatar-wrapper" v-if="item.type === 'image'"   > <viewer>
                            <img :src="item.media_url" style="width: 100px;" alt="">
                        </viewer></div>
                        <div class="ChatWindowText" v-else  v-html="item.msg.replace(/\n/g, '<br>')" ></div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <el-button  @click="delmsg(item.id)">撤回</el-button>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>


                </div>
            </li>
        </ul>

        <!--输入框-->

        <div class="mess-dialogue">
            <div class="mess-dialogue_content">
                <div class="InputArea">
                    <div class="InputBoxIcon">
                        <!-- 转接 -->  <el-tooltip class="item" effect="dark" content="将此用户转接给其他客服" placement="top">
                        <el-popover
                                placement="right"
                                width="300"
                                trigger="click"
                                v-model="TransferPopover"
                                @show="TransferShow"
                                @after-leave="TransferValue=''">
                            <el-select v-model="TransferValue" placeholder="请选择">
                                <el-option-group
                                        v-for="group in TransferOptions"
                                        :key="group.label"
                                        :label="group.label">
                                    <el-option
                                            v-for="item in group.options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                            <el-button type="danger" size="mini" style="margin-left: 20px;" @click="Transfer">
                                确定转接
                            </el-button>
                            <i class="el-icon-share icon_Upload" slot="reference"></i>
                        </el-popover>
                    </el-tooltip>
                        <span  class="addquick" style="" @click="showrightCon">
                            <a id="" href="javascript:">快捷回复</a>
                        </span>
                    </div>
                    <div class="InputArea-content">

                        <div class="InputArea-input">

                                                    <textarea id="inputAreaValue"  class="InputArea-textarea" v-model="Msg" @input ="inputFunc"
                                                              @focus="showiswrite"
                                                              @blur="hiddeniswrite"
                                                              data-autosize-on="true" placeholder="请输入需要咨询的问题" style="height: 42px;"></textarea>
                                                </div>
                                                <div id="drawerBtn" class="getDrawer" style="" v-show="drawerbtnshow">
                                                    <a id="images" href="javascript:"><form id="picture" enctype="multipart/form-data">
                                                        <div class="layui-box input-but  size"><img src="../../../assets/images/add.png" alt="">

                                                            <input
                                                                    class="fileinput"
                                                                    type="file"
                                                                    id="Updateimage"
                                                                    lay-verify="required"
                                                                    @change="kftoBase64()"
                                                                    accept="image/jpeg, image/png, image/jpg"
                                                            />
                                                        </div></form></a>
                                                </div>
                                                <div class="InputArea-btn" id="InputAreasendbtn" v-show="InputAreasendbtnshow" style="display: none;">
                                                    <div class="send changeSkinColor" @click="sendMesage">发送</div>
                                                </div>
                                            </div>
                                        </div>
                <div style="height: 160px" >

                </div>
                                    </div>
                                </div>
                                <!--右侧智能面板-->
        <div class="rightCon" v-if="rightConshow">
            <h2 class="ChatName">快捷回复 <span class="right" @click="hiddenrightCon">返回</span></h2>
                    <ul label="智能回复" name="SmartReply" class="quickreply">

                        <li  class="ChatOffLineHide" v-for="item in QuickreplyItem">
                            <div class="ChatOffLineDivCon">
                                <div class="ChatOffLineDivConWen">
                                    <span>标题：</span>
                                    <p class="AnswerTitle" v-html="item.QuickTitle.replace(/\n/g, '<br >')">
                                    </p>
                                </div>
                                <div class="ChatOffLineDivConWen">
                                    <span>答：</span>
                                    <pre class="AnswerText" v-html="item.QuickContent.replace(/\n/g, '<br >')">
                                    </pre>
                                </div>
                            </div>
                            <div class="ChatOffLineInput">
                                <el-button type="primary" size="small" plain @click="quickmessage(item.QuickContent.replace(/\n/g, '<br >'))">发送
                                </el-button>
                            </div>
                        </li>
                    </ul>
            </div>
        <el-dialog :visible.sync="dialogVisible" title="修改备注" append-to-body>
            <el-form ref="formData"   label-width="80px" label-position="left">
                    <el-input v-model="customerid" placeholder="Menu customer_id" type="hidden" clearable />
                <el-form-item label="昵称" prop="customer_nick_name">
                    <el-input v-model="customerName" placeholder="Menu customer_name" clearable/>
                </el-form-item>

            </el-form>
            <div style="text-align:right;">
                <el-button type="primary" @click="editcustomer">
                    修改
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {formatDate} from '@/util/date'
    const customer = {
        customer_id: '',
        customer_nick_name: ''
    }
    export default {
        name: "ChatBody",
        data() {
            return {
                Customerinfo: Object.assign({}, customer),
                customerName: "",
                customerid: "",
                customerImg: "",
                Msg: "",
                ActiveName: "SmartReply",
                AnswerTitle: "",
                AnswerText: "",
                imageUrl: "",
                extension_name: "",
                TransferValue: '',
                dialogVisible: false,
                TransferOptions: [],
                TransferPopover: false,
                editcustomer_id:'',
                InputAreasendbtnshow: false,
                drawerbtnshow: true,
                iswrite: false,
                rightConshow:false
            };
        },
        computed: {
            customerId() {
                this.Msg = "";
                this.customerName = this.$store.state.currentCustomer.customer_nick_name;
                this.customerid = this.$store.state.currentCustomer.customer_id;
                this.customerImg = this.$store.state.currentCustomer.customer_head_img_url;

                return this.$store.state.currentCustomer.customer_id;
            },
            ContactItem() {
                let megs = this.$store.state.currentRoomMessages;
                return megs;
            },
            QuickreplyItem() {
                let aimegs = this.$store.state.quickReply;
                return aimegs;
            },
        },
        mounted() {
//监听返回键

            if (window.history && window.history.pushState) {

                window.addEventListener('popstate',this.ClearCustomer,false);

            }

        },
        methods: {
            clearStatus() {
                this.Msg = "";
                this.AnswerTitle = "";
                this.AnswerText = "";
            },
            showrightCon(){
                this.rightConshow = true
            },
            hiddenrightCon(){
                this.rightConshow = false
            },
            hiddeniswrite(){
                this.iswrite = false
            },
            showiswrite(){
                this.iswrite = true
            },
            handleAddMenu(id,name) {
                this.dialogVisible = true
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate()
                    this.$refs['formData'].resetFields()
                })
            },
            delmsg(msgid){


                var that = this;
                this.axios.post("/api/admin/dialog/delmsg", {
                    customer_id: this.customerId,
                    msgid: msgid,
                }).then(resp => {
                    if (resp.data.code === 200) {
                        this.$store.commit('delOneMsg', this.customerId,msgid);
                        for (let iii = 0; iii < that.ContactItem.length; iii++) {
                            if (that.ContactItem[iii].id === msgid) {
                                that.ContactItem.splice(iii, 1);
                                return
                            }
                        }
                    }

                }, err => {
                    this.$message.error('发送失败，微信限制给固定用户发送的频率和时间，需要等待用户再次主动发起聊天才能够发送');
                    console.log(err)
                });

            },
            kftoBase64() {
                var that = this;
                var file = document.querySelector('input[type=file]').files[0];
                console.log("base64", file);
                var filename = file.name;
                var extName = filename.substring(filename.lastIndexOf('.') + 1);
                var reader = new FileReader();
                reader.onloadend = function () {
                    //把转换后的数据给id为base64Img的src属性
                    console.log(reader.result);
                    that.imageUrl = reader.result;
                    that.extension_name = extName;
                    that.kfupdataImg();
                    //这里调用了向后台发请求的代码
                };
                if (file) {
                    reader.readAsDataURL(file);
                }
            },
            kfupdataImg() {
                var that = this;
                this.axios.post("/api/admin/dialog", {
                    msg_type: "image",
                    customer_id: this.customerId,
                    extension_name: that.extension_name,
                    media_base64: that.imageUrl,
                }).then(resp => {
                    if (resp.data.result.media_url) {
                        this.ContactItem.push({
                            create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                            type: "image",
                            id: resp.data.result.id,
                            media_url:  resp.data.result.media_url,
                            oper_code: 2003,
                        });
                    }

                }, err => {
                    this.$message.error('发送失败，微信限制给固定用户发送的频率和时间，需要等待用户再次主动发起聊天才能够发送');
                    console.log(err)
                });

            },
            quickmessage(msgs,e) {
                this.Msg = msgs;
                let sendMsg = this.Msg;
                this.clearStatus();
                if (!sendMsg || sendMsg.replace(/\n/g, '').replace(/\s/g, '').length === 0) {
                    this.$message.error('不能发送空的内容');
                    return
                }
                this.axios.post("/api/admin/dialog", {
                    msg_type: "text",
                    customer_id: this.customerId,
                    msg: sendMsg,
                }).then(resp => {
                    this.ContactItem.push({
                        create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                        type: "text",
                        id: resp.data.result.id,
                        msg: sendMsg,
                        oper_code: 2003,
                    });
                }, err => {
                    this.$message.error('发送失败，微信限制给固定用户发送的频率和时间，需要等待用户再次主动发起聊天才能够发送');
                    console.log(err)
                });
                this.hiddenrightCon()
            },
            /**
             * 发送消息
             */
            sendMesage(e) {
                if (e.ctrlKey) {
                    this.Msg += '\n';
                    return
                }

                let sendMsg = this.Msg;
                this.clearStatus();
                if (!sendMsg || sendMsg.replace(/\n/g, '').replace(/\s/g, '').length === 0) {
                    this.$message.error('不能发送空的内容');
                    return
                }
                this.axios.post("/api/admin/dialog", {
                    msg_type: "text",
                    customer_id: this.customerId,
                    msg: sendMsg,
                }).then(resp => {
                    this.InputAreasendbtnshow = false;
                    this.drawerbtnshow = true;
                    this.ContactItem.push({
                        create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                        msg: sendMsg,
                        id: resp.data.result.id,
                        oper_code: 2003,
                    });
                }, err => {
                    this.$message.error('发送失败，微信限制给固定用户发送的频率和时间，需要等待用户再次主动发起聊天才能够发送');
                    console.log(err)
                });
            }
            ,
            editcustomer() {
                var that = this
                if (!this.customerid || this.customerName.replace(/\n/g, '').replace(/\s/g, '').length === 0) {
                    this.$message.error('不能发送空的内容');
                    return
                }
                    this.axios.post("/api/admin/editcustomer", {
                        msg_type: "text",
                        customer_id: this.customerid,
                        customer_nick_name: this.customerName,
                    }).then(resp => {
                        this.dialogVisible = false
                        this.$message.success('修改成功');
                    }, err => {
                        this.$message.error('发送失败，微信限制给固定用户发送的频率和时间，需要等待用户再次主动发起聊天才能够发送');
                        console.log(err)
                    });
            },
            /**
             * 显示转接select
             * @constructor
             */
            TransferShow() {
                this.axios.get('/api/admin/kf/online')
                    .then(resp => {
                        this.TransferOptions = resp.data;
                    });
            }
            ,
            /**
             * 将当前用户转接给其他客服
             * @constructor
             */
            Transfer() {
                let transferKfId = this.TransferValue;
                let customerId = this.customerId;

                this.axios.post('/api/admin/room/transfer', {
                    customer_id: customerId,
                    transfer_kf_id: transferKfId,
                }).then(resp => {
                    this.TransferValue = "";
                    this.TransferPopover = false;
                    this.$store.commit('transferRoom', this.customerId);
                    this.$store.commit('cleanCurrentCustomer');
                    this.$notify.success({
                        title: "客户转接",
                        message: `转接成功`,
                    });
                });
            }
            ,
            /**
             * 将当前用户转接给其他客服
             * @constructor
             */
            Endreception() {
                let customerId = this.customerId;

                this.axios.post('/api/admin/room/endreception', {
                    customer_id: customerId,
                }).then(resp => {
                    this.$store.commit('transferRoom', this.customerId);
                    this.$store.commit('cleanCurrentCustomer');
                    this.$notify.success({
                        title: "移除接待",
                        message: `移除成功`,
                    });
                });
            }
            ,
            Endreception() {
                let customerId = this.customerId;

                this.axios.post('/api/admin/room/endreception', {
                    customer_id: customerId,
                }).then(resp => {
                    this.$store.commit('transferRoom', this.customerId);
                    this.$store.commit('cleanCurrentCustomer');
                    this.$notify.success({
                        title: "移除接待",
                        message: `移除成功`,
                    });
                });
            }
            ,
            ClearCustomer() {
                this.$store.commit('cleanCurrentCustomer');
            }
            ,
            inputFunc() {
                let sendMsgres = this.Msg;
                if (!sendMsgres) {
                    this.InputAreasendbtnshow = false;
                    this.drawerbtnshow = true;
                } else {
                    this.InputAreasendbtnshow = true;
                    this.drawerbtnshow = false;
                }
            },
        }
        ,
        updated: function () {
            var container = document.getElementById("ChatWindow");
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        }
    }
</script>

<style scoped>
    .textarea {
        font-size: 12px;
    }

    .ChatName span {
        font-size: small;
        color: #000;
        float: right;
        margin-right: 10px;
    }
</style>